// 地址簿新增模块-简体中文
module.exports = {
  validate: {
    noEmail: "邮箱不得为空，请重新输入",
    noPhone: "手机号不得为空，请重新输入",
    errorReg: "输入长度为1-50位，可输入大小写字母、数字、符号 - . _ @",
    noPassword: "密码不得为空，请重新输入",
    pwdReg: "密码输入长度为8-32,允许输入数字、字母、特殊字符",
    pwdCheck: "两次密码输入不一致，请重新输入",
    pwdLengthReg: "密码长度范围为8-32，请确认输入",
    noCode: "请输入验证码",
    codeReg: "请输入6位数的验证码",
    nullText: "输入不得为空，请重新输入",
    phoneCheck: "两次输入手机号码不一致，请重新输入",
    emailNumReg: "邮箱输入长度为6-50位，请重新输入",
    emailReg: "邮箱输入有误，请重新输入",
    emailCheck: "两次输入邮箱账号不一致，请重新输入",
    noUsername: "密码不能包含账号，请重新输入",
    accountReg: "账号名输入有误，请重新输入",
  },
  area: {
    areaTitle: "区域管理",
    add: "新增区域",
    area: "区域",
    addNextArea: "新建下级区域",
    areaNameTip: "请输入区域名称",
    areaNameHold: "输入长度为1-20位，不可输入特殊符号",
    areaNumHold: "输入长度为1-4位，仅限输入数字，编号范围0-9999",
    areaNumTip: "请输入区域编号",
    areaName: "区域名称",
    checkAreaName: "区域名称不得为空，请重新输入",
    areaNameTip1: "区域名称不得为空",
    areaNameTip2: "区域名称输入有误，请重新输入",
    areaNum: "区域编号",
    checkAreaNum: "区域编号不得为空，请重新输入",
    lastLevel: "所属上级区域",
    checkLastLevel: "所属上级区域不得为空，请重新选择",
    lastLevelTip: "请选择所属上级区域",
    delInfo: "执行此删除任务将删除该区域数据且不可恢复",
    oneStep: "一级",
    twoStep: "二级",
    threeStep: "三级",
    fourStep: "四级",
    fiveStep: "五级",
    delAreaTip: "存在下级区域，不可删除",
    personArea: "该人员未绑定区域",
    areaType: "新增方式",
    addArea1: "单独添加",
    addArea2: "连续添加",
    addArea3: "矩阵添加",
    areaNameTop: "区域名称前缀",
    areaNameLast: "区域名称后缀",
    areaJoinHold: "请输入区域名称前缀",
    areaJoinHold1: "请输入区域名称后缀",
    startNum: "起始编号",
    checkStartNum: "起始编号输入有误，请重新输入",
    checkStartNum1: "起始编号输入不得为空，请重新输入",
    checkEndNum: "结束编号输入有误，请重新输入",
    checkEndNum1: "结束编号输入不得为空，请重新输入",
    endNum: "结束编号",

    topStart: "首部起始编号",
    checkTopStart: "首部起始编号输入有误，请重新输入",
    checkTopStart1: "首部起始编号输入不得为空，请重新输入",

    topEnd: "首部结束编号",
    checkTopEnd: "首部结束编号输入有误，请重新输入",
    checkTopEnd1: "首部结束编号输入不得为空，请重新输入",

    lastStart: "尾部起始编号",
    checkLastStart: "尾部起始编号输入有误，请重新输入",
    checkLastStart1: "尾部起始编号输入不得为空，请重新输入",

    lastEnd: "尾部结束编号",
    checkLastEnd: "尾部结束编号输入有误，请重新输入",
    checkLastEnd1: "尾部结束编号输入不得为空，请重新输入",

    topTip: "输入长度为1-2位，仅限输入数字，编号范围1-99",
    lastTip: "输入长度为1-2位，仅限输入数字，编号范围1-99",
    areaNameTest: "区域名称示例",
  },
  addressBook: {
    config: "工程配置",
    errorTip: "地址簿格式错误",
    upgrade: "地址簿升级管理",
    deviceIdTip: "请输入设备ID",
    deviceId: "设备ID",
    syncAll: "全部同步",
    sync: "同步",
    sysVersion: "当前系统地址簿版本",
    deviceVersion: "当前设备地址簿版本",
    syncTip: "同步指令下发成功",
  },
  newarea: {
    add: "添加区域",
    edit: "编辑区域",
    smallTip: "当前为最小区域层级，不可继续添加子区域",
    batch: "批量添加区域",
    batch1: "连续添加",
    batch2: "矩阵添加",
  },
  deviceSip: {
    saveTip: "请及时导出地址簿，否则退出页面后所有的数据将清空。",
    devMsg: "设备信息",
    list: "设备列表",
    add: "添加设备",
    edit: "编辑设备",
    batch: "批量添加设备",
    areaChosen: "区域级别选择",
    areaNum: "每个区域下新增设备数量",
    bacthTip:
      "当区域级别选择为栋，每个区域下新增设备数量为4，则表示在已创建的每个栋区域下都新增4个设备",
    note: "说明",
    baseConfig: "基本信息配置",
    deviceName: "设备名称",
    nameTip: "固定为所属组名加编号,例如1栋-1",
    function: "设备支持功能",
    net: "网络配置",
    netType: "网络类型",
    netTip1: "Static为静态网络，需要手动设置IP等信息。",
    netTip2: "DHCP为动态网络，由路由器自动分配IP等信息。",
    mask: "请输入子网掩码",
    gateway: "请输入网关",
    ip: "请输入IP地址",
    ipTip: "输入的IP地址需避开特殊IP，例如127.0.0.1等",
    dns1: "请输入DNS1",
    dns2: "请输入DNS2",
    sip1: "sip1信息配置",
    config: "信息配置",
    mode: "模式",
    mode1: "直连模式",
    mode2: "服务器模式",
    user: "请输入用户名",
    userTitle: "用户名",
    userTip: "默认为所述组名加编号,例如1-1-1",
    last: "请输入账号后缀",
    sipTip: "请输入SIP服务器已注册的用户名和密码",
    password: "请输入密码",
    passwordTitle: "密码",
    serverIp: "请输入serverIP",
    protocolType: "请选择协议类型",
    protocolTypeTitle: "协议类型",
    sip2: "sip2信息配置",
    more: "更多",
    close: "关闭",
    formatError: "格式错误，请重新输入",
    forbidTip: "禁止输入127.0.0.1,请重新输入",
    call: "呼入呼出",
    monitor: "监控",
    lift: "电梯控制",
    rtsp: "rtsp视频流",
    deviceTip: "设备支持功能不能为空，请重新选择",
    maskTip1: "子网掩码不能为空，请重新输入",
    maskTip2: "子网掩码格式错误,请重新输入",
    gatewayTip1: "网关不能为空，请重新输入",
    gatewayTip2: "网关格式错误,请重新输入",
    ipTip1: "IP地址不能为空，请重新输入",
    ipTip2: "IP地址格式错误,上限为255.254.254.253,首段非0,请重新输入",
    dns1Tip1: "DNS1不能为空，请重新输入",
    dns1Tip2: "DNS1格式错误,请重新输入",
    dns2Tip1: "DNS2格式错误,请重新输入",
    passwordTip1: "密码不能为空，请重新输入",
    serviceTip1: "serviceIp不能为空，请重新输入",
    serviceTip2: "serviceIp格式错误,请重新输入",
    sip2Tip: "您当前配置了sip2信息，请按规则填写完整",
    devnameTip1: "设备名称不能为空，请重新输入",
    devnameTip2: "设备名称格式错误，请重新输入",
    nameTip1: "用户名称不能为空，请重新选择",
    nameTip2: "用户名称不能为空，请重新选择",
    maxTip1: "当前区域设备数已达上限8台，不可继续添加",
    area: "区域",
    editArea: "编辑区域",
    addArea: "添加区域",
    batchArea: "批量添加区域",
    deleteArea: "删除区域",
    areaName: "区域名称",
    areaNo: "区域编号",
    importAddr: "导入地址簿",
    next: "下一步",
    areaTip1: "请先选择需要编辑的区域",
    areaTip2: "请先选择需要删除的区域",
    areaTip3: "您当前区域为空，暂不能批量添加设备，请先添加区域信息",
    noArea: "暂无区域配置",
    error: "数据异常",
    addDevice: "添加设备",
    editDevice: "编辑设备",
    delDevice: "删除设备",
    batchDevice: "批量添加设备",
    prev: "上一步",
    updateAddr: "更新设备地址簿",
    saveAddr: "保存地址簿",
    exportAddr: "导出地址簿",
    deleteTip: "是否删除设备",
    deleteTip2: "当前选中为区域，请返回区域配置进行删除",
    deleteTip3: "请先选择需要删除的设备",
    deviceTip1: "请先选择需要编辑的设备",
    deviceTip2: "请先选择区域，后添加设备",
    exportSuccess: "导出成功",
    xmlTip: "请上传地址簿的xml文件",
    xmlTip1: "请选择需要上传的xml文件",
    xmlTip2: "导入的地址簿与当前小区区域层级不一致，导入失败",
    areaConfig: "区域配置",
    deviceConfig: "设备配置",
    exportConfig: "预览导出",
    projectConfig: "项目配置",
    prevArea: "所属上级区域",
    areaNoTip: "开始编号大于结束编号,请重新填写",
    smallAreaTip: "当前为最小区域层级，不可继续添加子区域",
    areaNoTip1: "首部起始编号大于首部结束编号,请重新填写",
    areaNoTip2: "尾部起始编号大于尾部结束编号,请重新填写",
  },
  push: {
    list: "推送记录",
    productType: "产品型号",
    softwareName: "软件名称",
    versionNo: "版本号",
    time: "推送时间",
    invalidTime: "失效时间",
    upgrade: "升级",
    upgradeRecord: "查看升级记录",
    deviceType: "设备类型",
    deviceName: "设备名称",
    currentSoftName: "当前设备软件名称",
    currentSoftNo: "当前设备版本号",
    upgradeNo: "升级软件版本号",
    filterTip1: "请输入设备名称",
    filterTip2: "请选择软件名称",
    filterTip3: "请选择版本号",
    checkTip: "激活勾选",
    ota: "OTA升级",
    taskName: "任务名称",
    taskNameTip: "请输入任务名称",
    binName: "固件名称",
    upgradeType: "任务升级方式",
    done: "是否立即执行",
    upgradeTime: "升级时间",
  },
  check: {
    submit: "恭喜您，提交成功!",
    noSubmit: "糟糕，提交失败!",
    file: "选择文件",
    noFile: "未选择任何文件",
    projectName: "项目名称",
    projectNameTip: "请输入项目名称",
    describe: "描述",
    contentTip: "请输入内容",
    areaType: "区域层级",
    example: "例如：栋-单元-房号",
    areaTip: "区域编号格式错误，请重新输入",
    areaNameTip: "请输入层级名称",
    nameTip: "名称不得为空，请重新输入",
    nameError: "名称输入有误，请重新输入",
    nameLength: "名称输入长度为4~50，请重新输入",
    areaNullTip: "区域层级不得为空",
    formateError: "长度为1-6位，不可输入特殊符号",
    noAreaTip: "区域层级不得为空，请重新选择",
    maxFileTip: "文件大小超出限制",
    xmlTip: "请上传XML格式的文件",
  },
  book: {
    areaBy: "所属区域",
    list: "设备信息重复列表",
    repeatTip:
      "以下设备信息重复，请修改重复的设备信息，点击“ 确认” 后会判断设备输入信息的重复性。 ",
    coverTip: "本次操作会覆盖当前选中层级的批量添加数据",
    batchTip: "次批量添加设备生成的IP范围",
  },
  updateNewSip: {
    otaDeleteTip: "删除失败,只能删除未开始的任务",
    deleteArea1: "是否删除区域",
    deleteArea2: "同时，该区域以下的所有区域和设备将一并删除",
    codeRepeatTip: "同层级的区域编号不能重复，请重新输入当前的区域编号",
    nameRepeatTip: "同层级的区域名称不能重复，请重新输入当前的区域名称",
    deviceIp: "设备IP",
    callin: "呼入",
    callout: "呼出",
    systemMsg: "系统消息",
    batchIpTip: "本次批量添加设备生成的IP范围",
    ip: "IP地址",
    mask: "子网掩码",
    gateway: "网关",
    noData: "暂无",
    noAddressTip: "暂无可同步的地址簿数据",
    operator: "操作人",
    goTip: "点击跳转对应步骤",
    deviceNameTip: "输入长度为1-16位，不可输入特殊符号",
    filter1: "输入区域名称进行过滤",
    filter2: "输入区域名称或设备名称进行过滤",
    secret: "加密密码",
    secretTip: "请输入32位以内的密码，格式不限",
    noSecretTip: "未设置加密密码可忽略",
    setSecret: "设置地址簿加密密码",
    ignore: "忽略",
    emptyBookTip: "地址簿为空，暂时无法导出",
    errorSecret: "地址簿加密密码错误,请重新输入",
    other: "其他",
    doorAuth: "门禁",
    funTitle: "请勾选您添加的设备支持的功能",
    callInTip: "设备支持呼叫",
    callOutTip: "设备支持被呼叫",
    monitorTip: "设备支持被监控",
    doorTip: "设备支持开锁功能",
    liftTip: "设备支持控制电梯",
    maskTip: "请输入子网掩码,格式参考：255.255.255.255",
    gatewayTip: "请输入网关,格式参考：1.1.1.1",
    ip1: "请输入IP地址,格式参考：1.1.1.1",
    ipTip: "输入的IP地址需避开特殊IP，例如127.0.0.1等",
    dns1: "请输入DNS1,格式参考：1.1.1.1",
    dns2: "请输入DNS2,格式参考：1.1.1.1",
    serverIp: "请输入serverIp,格式参考：1.1.1.1或域名",
    successxml: "文件解析成功",
    groupCall: "群呼",
    groupCallTip: "开启后，可通过点击组呼图标，同是呼叫组内所有设备",
    record: "版本记录",
    export: "导出",
    sync: "同步",
    communityTip: "当前存在区域设备数据，禁止切换区域层级",
    areaNameTitle: "层级描述",
    noDataTip: "暂无数据",
    areaCodeDescriptionTip: "层级描述不可空，请填写完整",
    moduleName: "地址簿配置工具",
    userSipAccount: "固定为所属上级组区域编号+设备序号",
    devMax: "设备节点超出10000条限制，添加失败",
    areaMax: "区域节点超出10000条限制，添加失败",
    ipAndMaskTip1:
      "IP地址与子网掩码相关联,需要满足业务逻辑校验相与&后结果不全1或不全0",
    ipAndMaskTip2: "当出现业务校验规则错误后，请修改对应的IP地址",
    ipAndMaskTip3: "子网掩码与IP地址的业务校验规则错误,请修改IP地址",
    ipAndMaskTip4: "批量添加设备时，会自动跳过不满足业务逻辑校验的IP",
    correctMaskTip: "请先填写正确的子网掩码",
    correctIpTip: "请填写正确的IP地址",
  },
  newDeviceType:{
    indoorMachine: "室内机", 
    doorPhone: "门口机", 
    smallDoor:"小门口机",
    manage: "管理机", 
    wall: "围墙机",
    monitor: "网络摄像头", 
    unitGuard:"单元管理机",
    networkCard:"联网刷卡头",
    unitCard: "单元刷卡头",
    lift:"电梯联动模块",
    deviceTypeTip:"请选择设备类型"
  }
};
